<ng-container
  *ngIf="{
    product: product$ | async,
    article: article$ | async,
    articleRefs: articleRefs$ | async,
    articleListQueryParams: articleListQueryParams$ | async,
    assortmentTableState: assortmentTableState$ | async,
    activeTab: activeTab$ | async,
    productDocuments: productDocuments$ | async,
    washingInstructionIcons: washingInstructionIcons$ | async,
    washingInstructionGroups: washingInstructionGroups$ | async,
    technicalAttributesTableState: technicalAttributesTableState$ | async,
    productCertificationGroups: productCertificationGroups$ | async,
    pagination: pagination$ | async,
    showFacets: showFacets$ | async,
    sortDisabled: sortDisabled$ | async,
    facets: facets$ | async,
    breadcrumbs: breadcrumbs$ | async,
    isBelowLargeScreen: isBelowLargeScreen$ | async,
    printingTechnologiesGroups: printingTechnologiesGroups$ | async,
  } as data"
>
  <div class="position-relative border-bottom">
    <ul
      ngbNav
      pyNavSideScroll
      #nav="ngbNav"
      [activeId]="data.activeTab"
      (activeIdChange)="selectTab.emit($event)"
      class="nav-tabs nav active-tab-border dark-border side-scroll hide-on-print"
    >
      <li role="presentation" [ngbNavItem]="PdpTabTypes.ArticleList" [class.disabled]="!data.product?.articles?.length">
        <a ngbNavLink
          >{{ 'product.articles_tab' | cxTranslate
          }}<py-badge class="ml-2" [tag]="true">{{ data.product?.articles?.length || 0 }}</py-badge></a
        >
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="articleListTemplate"></ng-container>
        </ng-template>
      </li>

      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.TechnicalAttributes"
        [class.disabled]="!data.product?.extraInfo?.topics?.includes(productDetailsTopic.TECHNICAL_DATA_TABLE)"
      >
        <!-- Translation for papyrus: 'Technical characteristics' -->
        <a ngbNavLink>{{ 'product.technicalAttributes_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="technicalAttributesTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.Assortment"
        [class.disabled]="!data.product?.extraInfo?.topics?.includes(productDetailsTopic.ASSORTMENT_PACKAGING_TABLE)"
      >
        <!-- Translation for papyrus:: 'Range' -->
        <a ngbNavLink>{{ 'product.assortment_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="assortmentTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.CertificateInformation"
        [class.disabled]="!data.productCertificationGroups?.length"
      >
        <!-- Translation for papyrus: 'Certificate' -->
        <a ngbNavLink>{{ 'product.certificateInformation_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="certificateInformationTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.TechnicalCapabilities"
        [class.disabled]="(data.product?.extraInfo?.technicalCapabilities | json) === '{}'"
      >
        <!-- Translation for papyrus: 'Technical possibilities' -->
        <a ngbNavLink>{{ 'product.technicalCapabilities_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="technicalCapabilitiesTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.PrintingTechnologies"
        [class.disabled]="!data.printingTechnologiesGroups?.length"
      >
        <a ngbNavLink>{{ 'product.printingTechnologies_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="printingTechnologiesTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.Applications"
        [class.disabled]="data.product?.extraInfo?.applications?.length === 0"
      >
        <a ngbNavLink>{{ 'product.applications_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="applicationsTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        role="presentation"
        [ngbNavItem]="PdpTabTypes.ProductInformation"
        [class.disabled]="
          !data.product?.longDescription &&
          !data.product?.uniqueSellingPoints?.points?.length &&
          !data.product?.productDownloadables &&
          !data.product?.datasheet &&
          !(data.article?.safetyDatasheetUrl || data.article?.datasheet?.url) &&
          !data.productDocuments?.length &&
          !(data.washingInstructionIcons?.length || data.washingInstructionGroups?.length)
        "
      >
        <!-- Translation for papyrus: 'Documents & Links' -->
        <a ngbNavLink>{{ 'product.productInformation_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="productInformationTemplate"> </ng-container>
        </ng-template>
      </li>

      <li role="presentation" *ngFor="let tabContainer of tabContainers" [ngbNavItem]="tabContainer.uid">
        <a ngbNavLink>{{ tabContainer.tabName }}</a>

        <ng-template ngbNavContent>
          <div class="mt-6">
            <ng-container [cxComponentWrapper]="tabContainer"></ng-container>
          </div>
        </ng-template>
      </li>
    </ul>
  </div>

  <div [ngbNavOutlet]="nav"></div>

  <ng-template #articleListTemplate>
    <div>
      <div class="hide-on-print d-block d-xl-flex justify-content-between py-5 border-bottom">
        <div class="d-flex">
          <py-catalog-filter-breadcrumbs [breadcrumbs]="data.breadcrumbs"></py-catalog-filter-breadcrumbs>
        </div>

        <div class="d-flex justify-content-end mt-3 mt-xl-0 mb-2 mb-xl-0">
          <h2 class="cx-visually-hidden">
            {{ 'product.articles_tab' | cxTranslate }}
          </h2>
          <py-catalog-sort
            *ngIf="!data.sortDisabled"
            class="w-100"
            [searchResults$]="searchResults$"
            [activeTabIndex$]="activeTabIndex$"
            [sortOptionToHide]="sortDefaultOption"
          ></py-catalog-sort>
          <py-action-button
            [ariaLabel]="'common.download_tooltip' | cxTranslate"
            [ngbTooltip]="'common.download_tooltip' | cxTranslate"
            (click)="goToPrintProductArticles(data.product?.name, data.product?.code, data.product?.categoryRef)"
            [buttonClass]="'btn btn-ternary btn-icon ml-2'"
          >
            <i nz-icon nzType="download"></i>
          </py-action-button>
        </div>
        <div *ngIf="data.showFacets" class="d-block d-xl-none">
          <button
            class="btn btn-ternary w-100"
            (click)="openDrawer()"
            *ngIf="{ customFilterCount: customFilterCount$ | async } as data"
          >
            <i *ngIf="data.customFilterCount === 0" nz-icon nzType="filter" outline class="mr-2"></i>
            {{ 'catalog.filter_tab' | cxTranslate }}
            <py-badge [tag]="true" *ngIf="data.customFilterCount > 0">{{ data.customFilterCount }}</py-badge>
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3 d-none d-xl-block hide-on-print" *ngIf="data.showFacets">
          <ng-container *ngTemplateOutlet="facetsTemplate"></ng-container>
        </div>
        <div class="col-12" [ngClass]="{ 'col-xl-9': data.showFacets, 'col-xl-12': !data.showFacets }">
          <py-catalog-article-list
            [articleRefs]="data.articleRefs"
            [queryParams]="data.articleListQueryParams"
            [showAttributesInSeparateColumn]="data.isBelowLargeScreen || !data.showFacets"
            [itemListType]="ltemListTypePDP"
          ></py-catalog-article-list>
          <div class="footer pt-8 hide-on-print" *ngIf="data.product?.articles?.length > 6">
            <py-show-per-page
              [basicOptionsMode]="true"
              [options]="paginationOptions"
              class="d-flex justify-content-center mb-10 mb-xl-0"
              [formGroup]="formGroup"
              [controlName]="'pageSize'"
            ></py-show-per-page>
            <py-load-more
              *ngIf="data.pagination"
              [totalItemCount]="data.pagination.totalResults"
              [totalPageCount]="data.pagination.totalPages"
              [currentPageNumber]="data.pagination.currentPage"
              [itemCount]="data.articleRefs?.length || 0"
              (dispatch)="nextPage($event)"
              [totalItemCountName]="'catalog.pdp.loadMore_hint' | cxTranslate"
            ></py-load-more>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #productInformationTemplate>
    <h2 class="cx-visually-hidden">
      {{ 'product.productInformation_tab' | cxTranslate }}
    </h2>
    <div class="row mt-6 product-information">
      <div
        *ngIf="data.product?.uniqueSellingPoints?.points?.length || data.product?.longDescription"
        class="col-12 col-md-6 mb-4 mb-md-0"
      >
        <div *ngIf="data.product.uniqueSellingPoints?.points?.length" class="mb-4">
          <ul>
            <li *ngFor="let point of data.product?.uniqueSellingPoints?.points">
              <i nz-icon nzType="check" class="mr-2 text-secondary"></i>
              <span class="ml-2">{{ point.point }}</span>
            </li>
          </ul>
        </div>

        <div *ngIf="data.product.longDescription" class="mb-4">
          <p class="long-description">
            <span [innerHTML]="data.product?.longDescription"></span>
          </p>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div *ngIf="!!data.article?.safetyDatasheetUrl" class="mb-3">
          <cx-generic-link [url]="data.article?.safetyDatasheetUrl" target="_blank">
            <div class="d-flex align-items-center mb-2">
              <i nz-icon nzType="file-pdf" nzTheme="fill" class="py-color-secondary d-flex"></i>
              <span class="ml-2">{{ 'article.safetyDatasheet_tooltip' | cxTranslate }}</span>
            </div>
          </cx-generic-link>
        </div>

        <cx-generic-link class="mb-3" *ngIf="!!data.article?.datasheet?.url" [url]="data.article?.datasheet?.url" target="_blank">
          <div class="d-flex align-items-center mb-2">
            <i nz-icon nzType="file-pdf" nzTheme="fill" class="py-color-secondary d-flex"></i>
            <span class="ml-2">{{ 'article.datasheet_tooltip' | cxTranslate }}</span>
          </div>
        </cx-generic-link>

        <cx-generic-link
          class="mb-3"
          *ngIf="!!data.product?.datasheet?.url && !data.article?.datasheet?.url"
          [url]="data.product?.datasheet?.url"
          target="_blank"
        >
          <div class="d-flex align-items-center mb-2">
            <i nz-icon nzType="file-pdf" nzTheme="fill" class="py-color-secondary d-flex"></i>
            <span class="ml-2">{{ 'product.datasheet_tooltip' | cxTranslate }}</span>
          </div>
        </cx-generic-link>

        <cx-generic-link
          class="mb-3"
          *ngFor="let productDownloadable of data.product?.productDownloadables"
          [url]="productDownloadable.downloadUrl"
          target="_blank"
        >
          <div class="d-flex align-items-center mb-2">
            <i nz-icon nzType="file-pdf" nzTheme="fill" class="py-color-secondary d-flex"></i>
            <span class="ml-2">{{ productDownloadable.linkText }}</span>
          </div>
        </cx-generic-link>

        <cx-generic-link
          class="mb-3"
          *ngFor="let productDocument of data.productDocuments"
          [url]="productDocument.downloadUrl"
          target="_blank"
        >
          <div class="d-flex align-items-center mb-2">
            <i nz-icon nzType="file-pdf" nzTheme="fill" class="py-color-secondary d-flex"></i>
            <span class="ml-2">{{ productDocument.title }}</span>
          </div>
        </cx-generic-link>
      </div>

      <div class="mb-2" *ngIf="data.washingInstructionIcons?.length || data.washingInstructionGroups?.length">
        <div class="d-flex mb-2">
          <img
            *ngFor="let instructionIcon of data.washingInstructionIcons || []; let i = index"
            class="instruction-icon"
            [ngClass]="{ 'ml-2': i > 0 }"
            [pyMedia]="instructionIcon.icon"
            [alt]="instructionIcon.name"
            [ngbTooltip]="instructionIcon.name"
          />
        </div>
        <div *ngFor="let group of data.washingInstructionGroups || []">
          <h4>{{ group.description }}</h4>
          <ul class="mt-1 mb-2">
            <li *ngFor="let cert of group.certificates">
              <i nz-icon nzType="check" class="mr-2 text-secondary"></i>
              <span class="ml-2">{{ cert.description }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #certificateInformationTemplate>
    <div class="d-block d-lg-flex mt-6 justify-content gap-5">
      <h2 class="cx-visually-hidden">
        {{ 'product.certificateInformation_tab' | cxTranslate }}
      </h2>
      <div class="certificate-group mb-7 mb-lg-0" *ngFor="let group of data.productCertificationGroups || []">
        <h3 class="h4 pb-2">{{ group.description }}</h3>
        <ul class="mb-2">
          <li class="pt-2" *ngFor="let cert of group.certificates">
            <i nz-icon nzType="check" class="mr-2 text-success"></i>
            {{ cert.description }}
          </li>
        </ul>
      </div>
    </div>
  </ng-template>

  <ng-template #applicationsTemplate>
    <div class="mt-6">
      <h2 class="cx-visually-hidden">
        {{ 'product.applications_tab' | cxTranslate }}
      </h2>
      <h3 class="h4">{{ 'catalog.pdp.applications_text' | cxTranslate }}</h3>
      <ul class="mb-2">
        <li class="pt-2" *ngFor="let application of data.product?.extraInfo?.applications || []">
          <i nz-icon nzType="check" class="mr-2 text-success"></i>
          {{ application }}
        </li>
      </ul>
    </div>
  </ng-template>

  <ng-template #technicalCapabilitiesTemplate>
    <div class="mt-7">
      <h2 class="cx-visually-hidden">
        {{ 'product.technicalCapabilities_tab' | cxTranslate }}
      </h2>
      <div class="row mb-8 mb-lg-5" *ngFor="let capability of data.product?.extraInfo?.technicalCapabilities.entry | keyvalue">
        <div class="col-md-4">
          <h6>{{ capability.value.key }}</h6>
        </div>
        <div class="col-md-8 mt-2">
          <span class="technical-capabilities">{{ capability.value.value }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #printingTechnologiesTemplate>
    <div class="mt-7">
      <h2 class="cx-visually-hidden">
        {{ 'product.printingTechnologies_tab' | cxTranslate }}
      </h2>
      <div *ngFor="let group of data.printingTechnologiesGroups || []">
        <h5>{{ group.description }}</h5>
        <ul class="mb-2">
          <li *ngFor="let cert of group.certificates">
            <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-2 text-primary"></i>
            <span>{{ cert.description }}</span>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>

  <ng-template #technicalAttributesTemplate>
    <h2 class="cx-visually-hidden">
      {{ 'product.technicalAttributes_tab' | cxTranslate }}
    </h2>
    <ng-container
      [ngSwitch]="
        !!data.technicalAttributesTableState?.error
          ? 'error'
          : !!data.technicalAttributesTableState?.loading
            ? 'loading'
            : !data.technicalAttributesTableState?.data?.attributes?.length
              ? 'empty'
              : 'ready'
      "
    >
      <ng-container *ngSwitchCase="'error'" [ngTemplateOutlet]="errorTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'loading'" [ngTemplateOutlet]="loadingTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'empty'">
        <div class="text-center py-6">{{ 'product.noTechnicalDataAvailable_text' | cxTranslate }}</div>
      </ng-container>
      <ng-container *ngSwitchCase="'ready'">
        <py-technical-attributes-table
          [attributes]="data.technicalAttributesTableState?.data?.attributes"
          [pdpTypeSkuPicker]="false"
        >
        </py-technical-attributes-table>
        <p class="pt-5">
          {{ 'product.technicalAttributesDisclaimer_text' | cxTranslate }}
        </p>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #assortmentTemplate>
    <h2 class="cx-visually-hidden">
      {{ 'product.assortment_tab' | cxTranslate }}
    </h2>
    <ng-container
      [ngSwitch]="
        !!data.assortmentTableState?.error
          ? 'error'
          : !!data.assortmentTableState?.loading
            ? 'loading'
            : !data.assortmentTableState?.data?.assortment?.length
              ? 'empty'
              : 'ready'
      "
    >
      <ng-container *ngSwitchCase="'error'" [ngTemplateOutlet]="errorTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'loading'" [ngTemplateOutlet]="loadingTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'empty'">
        <div class="text-center py-6">{{ 'product.noAssortmentDataAvailable_text' | cxTranslate }}</div>
      </ng-container>
      <ng-container *ngSwitchCase="'ready'">
        <div class="d-flex justify-content-between align-items-center">
          <ul class="py-6">
            <li class="pr-4 d-block d-md-inline">
              <i nz-icon nzType="reamed" nzTheme="outline" class="pr-2 icon"></i>{{ 'product.reamed_heading' | cxTranslate }}
            </li>
            <li class="pr-4 d-block d-md-inline">
              <i nz-icon nzType="bulk_on_flex" nzTheme="outline" class="pr-2 icon"></i
              >{{ 'product.unreamed_heading' | cxTranslate }}
            </li>
            <li class="pr-4 d-block d-md-inline">
              <i nz-icon nzType="bulk" nzTheme="outline" class="pr-2 icon"></i>{{ 'product.bulked_heading' | cxTranslate }}
            </li>
          </ul>
          <py-action-button
            [ariaLabel]="'catalog.print_action' | cxTranslate"
            [ngbTooltip]="'catalog.print_action' | cxTranslate"
            [buttonClass]="'btn btn-ternary btn-icon ml-2 hide-on-print'"
            (click)="printAssortment()"
          >
            <i nz-icon nzType="printer"></i>
          </py-action-button>
        </div>
        <py-assortment-table
          [assortment]="data.assortmentTableState?.data?.assortment"
          [grammages]="data.assortmentTableState?.data?.grammages"
          [pdpTypeSkuPicker]="false"
        ></py-assortment-table>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #loadingTabTemplate>
    <cx-spinner class="py-6"></cx-spinner>
  </ng-template>

  <ng-template #errorTabTemplate>
    <div class="text-center py-6">
      <i nz-icon nzType="exclamation-circle-o" class="text-danger mr-2 align-text-bottom"></i>
      <span>{{ 'errors.unexpectedError_message' | cxTranslate }}</span>
    </div>
  </ng-template>

  <ng-template #drawerTemplate>
    <py-drawer-template [title]="'catalog.filter_tab' | cxTranslate" [body]="drawerBody"> </py-drawer-template>

    <ng-template #drawerBody>
      <div class="pt-2 px-4">
        <ng-container *ngTemplateOutlet="facetsTemplate"></ng-container>
      </div>
    </ng-template>
  </ng-template>

  <ng-template #facetsTemplate>
    <ng-container *ngFor="let facet of data.facets">
      <py-catalog-filter-facet
        [initialCollapsed]="initialCollapsed(facet)"
        [initialShowAll]="initialShowAll(facet)"
        [facet]="facet"
        [initialCollapsed]="false"
        (handleFilter)="handleChange($event)"
        (handleShowAll)="handleShowAll($event, facet)"
      ></py-catalog-filter-facet>
    </ng-container>

    <py-catalog-filter-reset
      class="d-flex justify-content-start py-6 border-bottom"
      *ngIf="!!data.breadcrumbs?.length"
      (resetFacets)="onResetFacets()"
      [showIconRight]="false"
    ></py-catalog-filter-reset>
  </ng-template>
</ng-container>
